import { Link } from 'react-router-dom';

export default function ServicesGrid() {
  const services = [
    {
      icon: 'ri-sun-line',
      title: 'Photovoltaik (PV-Anlage)',
      description: 'Wir planen und installieren Ihre Photovoltaikanlage – von der Beratung bis zur Inbetriebnahme. Senken Sie Ihre Stromkosten und profitieren Sie von sauberer, erneuerbarer Energie.',
      link: '/leistungen/photovoltaik',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Alarmanlagen',
      description: 'Schützen Sie Ihr Zuhause oder Ihren Betrieb mit modernster Sicherheitstechnik. Wir installieren und warten zuverlässige Alarmsysteme, die rund um die Uhr für Ihre Sicherheit sorgen.',
      link: '/leistungen/alarmanlagen',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Blitzschutz',
      description: 'Professioneller Blitz- und Überspannungsschutz für Gebäude und Anlagen. Wir schützen Ihre Elektronik und Infrastruktur zuverlässig vor den Folgen von Blitzeinschlägen.',
      link: '/leistungen/blitzschutz',
    },
    {
      icon: 'ri-tools-line',
      title: 'Elektroinstallationen',
      description: 'Von der Neuinstallation bis zur Sanierung bestehender Anlagen – wir führen alle Elektroarbeiten fachgerecht und normgerecht aus, für Privathaushalte und Gewerbebetriebe.',
      link: '/leistungen/elektroinstallationen',
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Beleuchtung',
      description: 'Wir entwickeln individuelle Lichtkonzepte für Wohn- und Gewerberäume. Von energieeffizienter LED-Technik bis hin zu stimmungsvoller Akzentbeleuchtung – alles aus einer Hand.',
      link: '/leistungen/beleuchtung',
    },
  ];

  return (
    <section id="leistungen" className="py-16 sm:py-20 px-4 sm:px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1A2B4A] mb-4">Unsere Leistungen</h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            Professionelle Elektrotechnik-Lösungen für Privat- und Gewerbekunden
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-lg p-6 sm:p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col h-full"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-[#F4B942]/10 rounded-lg mb-5">
                <i className={`${service.icon} text-3xl text-[#F4B942]`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#1A2B4A] mb-3 min-h-[3rem] flex items-center">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6 flex-grow text-sm leading-relaxed">
                {service.description}
              </p>
              <Link
                to={service.link}
                className="inline-flex items-center text-[#F4B942] font-semibold hover:text-[#e5a832] transition-colors cursor-pointer whitespace-nowrap"
              >
                Mehr erfahren
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
